<template>
    <div class="all-tags-modal">
        <v-menu
            class="tags-modal-wrap"
            offset-y
            :close-on-content-click="close"
        >
            <template v-slot:activator="{ on, attrs }">
                <v-btn
                    class="tags-modal-btn btn-shadow"
                    v-bind="attrs"
                    v-on="on"
                    @click="close = false"
                >
                    <v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
            </template>
            <v-window class="v-sheet doropdown-content tags-doropdown">
                <h4>{{ $TL.allTags }}</h4>
                <v-list class="d-flex flex-wrap" v-if="data">
                    <v-btn
                        v-for="(item, i) in data"
                        :class="[
                            'tag-item',
                            $store.state.mixins.isTagsActive === i && 'active'
                        ]"
                        :key="i"
                        @click="tags_click(item.name, i)"
                    >
                        {{ item.name }}
                    </v-btn>
                </v-list>
            </v-window>
        </v-menu>
    </div>
</template>

<script>
export default {
    name: "all-tags-modal",
    props: {
        data: {
            type: Array,
            default: () => {
                return [];
            }
        }
    },
    data() {
        return {
            close: false
        };
    },

    components: {},
    created() {},
    mounted() {},
    beforeDestroy() {},
    methods: {
        tags_click(tagsName, key) {
            this.close = true;
            this.$emit("tagsClick", tagsName, key);
        }
    }
};
</script>

<style lang="scss">
.all-tags-modal {
    z-index: 400;
}

.tags-doropdown {
    width: 75vw;
    padding: 16px 12px 0 20px;

    h4 {
        font-size: 16px;
        color: #888888;
        margin-bottom: 14px;
    }

    .tag-item {
        font-size: 14px;
        padding: 2px 10px;
        border-radius: 22px;
        margin: {
            right: 8px;
            bottom: 8px;
        }
        border: 1px solid rgba(#0063c4, 0.4);

        &:hover,
        &.active {
            background-color: rgba(#0063c4, 0.6);
            span {
                color: $color-white;
            }
        }
    }
}
</style>
